import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/subcon/invoices";

//#region state
const state = {
  subconInvoices: [],
  lastFormNumber: null,
  subconInvoice: {},
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "Detail Subcon Invoice", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastFormNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/form-number`);
      if (response.status === 200) {
        let num = null;
        let date = new Date();
        if (response.data === "New") {
          num = `SCI.${date.getFullYear()}.${date.getMonth() + 1}.00001`;
        } else {
          const lastNumber = response.data ? response.data.split(".")[3] : "";
          const ctx = "" + (parseInt(lastNumber) + 1);
          const end = lastNumber.substr(0, lastNumber.length - ctx.length) + ctx;
          num = `SCI.${date.getFullYear()}.${date.getMonth() + 1}.${end}`;
        }
        context.commit("SET_LAST_FORM_NUMBER", num);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context) {
    try {
      const response = await api.get(`${BASE_URL}`);

      if (response.status === 200) {
        context.commit("SET_SUBCON_INVOICES", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, subconInvoiceId) {
    try {
      const response = await api.get(`${BASE_URL}/${subconInvoiceId}`);
      // if (response.status === 200) {
      //   context.commit("SET_SUBCON_INVOICE", response.data);
      // }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
        context.dispatch(
          "toast",
          { type: "success", message: "Success Updated Data" },
          { root: true }
        );
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async delete(context, id) {
    try {
      const response = await api.deleted(`${BASE_URL}/${id}`);
      if (response.status === 200) {
        route.push({ name: "Subcon Invoice" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAccounts(context, payFor) {
    try {
      const response = await api.get(`${BASE_URL}/account/${payFor}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async updateTaxDate(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/tax-date`, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Updated Data" },
          { root: true }
        );
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getSubcon() {
    try {
      const response = await api.get(`${BASE_URL}/list-subcon`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getSpkSubconById(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/list-spk-subcon/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LAST_FORM_NUMBER(state, payload) {
    state.lastFormNumber = payload;
  },
  SET_SUBCON_INVOICE(state, payload) {
    state.subconInvoice = payload;
  },
  SET_SUBCON_INVOICES(state, payload) {
    state.subconInvoices = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
